function BroadcastService($q, AppSettings, AuthService, CommonService) {
    'ngInject';
  
    const service = {};
  
    // 방송 목록
    service.list = function(params) {
      const url = AppSettings.apiUrl.restRoot + 'broadcast/list';
  
      return CommonService.post(url, params);
    };
  
    // 방송 추가/수정
    service.set = function(params) {
      const url = AppSettings.apiUrl.restRoot + 'broadcast/set';
  
      return CommonService.post(url, params);
    };
  
    // 방송 삭제
    service.remove = function(params) {
      const url = AppSettings.apiUrl.restRoot + 'broadcast/remove';
  
      return CommonService.post(url, params);
    };
  
    return service;
  
  }
  
  export default {
    name: 'BroadcastService',
    fn: BroadcastService
  };
  